import { render, staticRenderFns } from "./shareCode.vue?vue&type=template&id=06d28a8e&"
import script from "./shareCode.vue?vue&type=script&lang=js&"
export * from "./shareCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports